import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUTS = [
  { v: "a_contacter", t: "À contacter", c: "bg-[#faf7f1] text-[#9E7B41] border-[#e0d3ba]" },
  { v: "appele", t: "Appelé", c: "bg-sky-50 text-sky-800 border-sky-200" },
  { v: "devis_envoye", t: "Devis envoyé", c: "bg-amber-50 text-amber-800 border-amber-200" },
  { v: "vendu", t: "Vendu", c: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  { v: "perdu", t: "Perdu", c: "bg-zinc-100 text-zinc-600 border-zinc-200" },
];

export const statutOf = (l) => l.statut || "a_contacter";

export function LeadStatutSelect({ lead, authHeader, onChanged }) {
  const cur = STATUTS.find((s) => s.v === statutOf(lead)) || STATUTS[0];
  const change = async (statut) => {
    try {
      await axios.patch(`${API}/leads/${lead.id}/statut`, { statut }, { headers: authHeader() });
      onChanged(lead.id, statut);
      toast.success(`Statut : ${STATUTS.find((s) => s.v === statut).t}`);
    } catch { toast.error("Statut non enregistré."); }
  };
  return (
    <select value={cur.v} onChange={(e) => change(e.target.value)} data-testid={`lead-statut-${lead.id}`}
      aria-label="Statut du client"
      className={`rounded-full border px-3 py-1 text-xs font-semibold cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#9E7B41]/30 ${cur.c}`}>
      {STATUTS.map((s) => <option key={s.v} value={s.v}>{s.t}</option>)}
    </select>
  );
}
